/*
 * FLP kit (Founder Love Story) page behaviour. Loaded (defer) by every flp-* section through
 * snippets/flp-head.liquid; runs once per page.
 *   - lazy background photos ([data-flp-bg])
 *   - review-quote carousel ([data-flp-carousel])
 *   - dialogs (study / formula / research)
 *   - review filters, search, sort, paging ([data-flp-reviews])
 *   - sticky bar ([data-flp-sticky])
 *   - current month ([data-current-month]) and FAQ deep links
 * No cart logic here (that is assets/flp-offer-gifts.js). Optional globals are guarded.
 * See docs/lp-structures/founder-love-story.md
 */
(function () {
  'use strict';
  if (window.FLPKit) return;
  window.FLPKit = { version: 1 };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function init() {
    /* ---------- lazy background photos ---------- */
    var lazy = $$('[data-flp-bg]');
    function reveal(el) {
      var url = el.getAttribute('data-flp-bg');
      if (!url) return;
      el.style.backgroundImage = "url('" + url + "')";
      el.removeAttribute('data-flp-bg');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
      }, { rootMargin: '900px 0px' });
      lazy.forEach(function (el) { io.observe(el); });
    } else {
      lazy.forEach(reveal);
    }
    // dialogs are display:none until opened, so reveal their photos on open
    window.FLPKit.reveal = reveal;

    /* ---------- swipe helper ---------- */
    function swipe(el, prev, next) {
      var start = null;
      el.addEventListener('pointerdown', function (e) { start = { x: e.clientX, y: e.clientY }; });
      el.addEventListener('pointerup', function (e) {
        if (!start) return;
        var dx = e.clientX - start.x, dy = e.clientY - start.y;
        start = null;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) { (dx > 0 ? prev : next)(); }
      });
      el.addEventListener('pointercancel', function () { start = null; });
    }

    /* ---------- review-quote carousel ---------- */
    $$('[data-flp-carousel]').forEach(function (car) {
      var slides = $$('.quote-slide', car), dots = $$('[data-slide]', car), cur = 0;
      if (!slides.length) return;
      function show(i) {
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (s, j) { s.hidden = j !== cur; s.setAttribute('aria-hidden', String(j !== cur)); });
        dots.forEach(function (d, j) { d.setAttribute('aria-pressed', String(j === cur)); });
      }
      dots.forEach(function (b, i) { b.addEventListener('click', function () { show(i); }); });
      car.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); show(cur + (e.key === 'ArrowRight' ? 1 : -1)); }
      });
      swipe(car, function () { show(cur - 1); }, function () { show(cur + 1); });
      show(0);
    });

    /* ---------- dialogs ---------- */
    function openDialog(id) {
      var d = document.getElementById(id);
      if (!d || typeof d.showModal !== 'function') return;
      $$('[data-flp-bg]', d).forEach(reveal);
      if (!d.open) d.showModal();
      document.body.classList.add('dialog-open');
      syncSticky();
    }
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      if (t.closest('[data-open-study]')) { openDialog('study'); return; }
      if (t.closest('[data-open-research]')) { openDialog('research'); return; }
      if (t.closest('[data-open-formula],[data-formula]')) { openDialog('formula'); return; }
      var c = t.closest('[data-close]');
      if (c && c.closest('dialog')) { c.closest('dialog').close(); return; }
      var cl = t.closest('[data-close-link]');
      if (cl && cl.closest('dialog')) { cl.closest('dialog').close(); }
    });
    $$('.flp dialog').forEach(function (d) {
      d.addEventListener('close', function () { document.body.classList.remove('dialog-open'); syncSticky(); });
      d.addEventListener('click', function (e) {
        if (e.target !== d) return;
        var r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      });
    });

    /* ---------- reviews ---------- */
    $$('[data-flp-reviews]').forEach(function (wrap) {
      var box = $('[data-review-results]', wrap);
      if (!box) return;
      var rows = $$('.review-row', box);
      var size = parseInt(wrap.getAttribute('data-page-size'), 10) || 4;
      var filter = 'all', limit = size;
      var q = $('[data-review-search]', wrap), rs = $('[data-review-rating]', wrap), so = $('[data-review-sort]', wrap);
      var more = $('[data-review-more]', wrap), empty = $('[data-review-empty]', wrap), count = $('[data-review-count]', wrap);
      function cats(r) { return (r.getAttribute('data-category') || '').toLowerCase().split('|').map(function (x) { return x.trim(); }); }
      function run() {
        var query = q ? q.value.trim().toLowerCase() : '';
        var rating = rs ? rs.value : 'all';
        var sort = so ? so.value : 'featured';
        var m = rows.filter(function (r) {
          return (filter === 'all' || cats(r).indexOf(filter.toLowerCase()) >= 0) &&
            (!query || (r.getAttribute('data-search') || '').indexOf(query) >= 0) &&
            (rating === 'all' || r.getAttribute('data-rating') === rating);
        });
        m.sort(function (a, b) {
          if (sort === 'highest' || sort === 'lowest') {
            var d = (Number(b.getAttribute('data-rating')) - Number(a.getAttribute('data-rating'))) * (sort === 'highest' ? 1 : -1);
            if (d) return d;
          }
          return Number(a.getAttribute('data-order')) - Number(b.getAttribute('data-order'));
        });
        rows.forEach(function (r) { r.hidden = true; });
        m.forEach(function (r, i) { box.appendChild(r); r.hidden = i >= limit; });
        if (count) count.textContent = Math.min(limit, m.length) + ' of ' + m.length + ' reviews shown' + (filter === 'all' ? '' : ' for ' + filter);
        if (more) more.hidden = m.length <= limit;
        if (empty) empty.hidden = m.length > 0;
      }
      var btns = $$('[data-filter]', wrap);
      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          filter = b.getAttribute('data-filter'); limit = size;
          btns.forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
          run();
        });
      });
      if (q) q.addEventListener('input', function () { limit = size; run(); });
      [rs, so].forEach(function (el) { if (el) el.addEventListener('change', function () { limit = size; run(); }); });
      if (more) more.addEventListener('click', function () { limit += size; run(); });
      var reset = $('[data-reset-reviews]', wrap);
      if (reset) reset.addEventListener('click', function () {
        filter = 'all'; limit = size;
        if (q) q.value = '';
        if (rs) rs.value = 'all';
        btns.forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-filter') === 'all')); });
        run();
      });
      run();
    });

    /* ---------- sticky bar ---------- */
    var sticky = $('[data-flp-sticky]');
    var heroCta = $('[data-flp-hero-cta]');
    function visible(e) { var r = e.getBoundingClientRect(); return r.height > 0 && r.bottom > 0 && r.top < window.innerHeight - 90; }
    function syncSticky() {
      if (!sticky) return;
      var pastHero = heroCta ? heroCta.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var actionVisible = $$('.flp .cta').some(function (c) { return !c.closest('[data-flp-sticky]') && !c.closest('dialog') && visible(c); });
      var show = pastHero && !actionVisible && !$('dialog[open]');
      sticky.classList.toggle('visible', show);
      if (show) { sticky.removeAttribute('inert'); } else { sticky.setAttribute('inert', ''); }
      sticky.setAttribute('aria-hidden', String(!show));
    }
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () { syncSticky(); queued = false; });
    }, { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();

    /* ---------- current month + FAQ deep links ---------- */
    try {
      var month = new Intl.DateTimeFormat('en-US', { month: 'long', timeZone: 'America/New_York' }).format(new Date());
      $$('[data-current-month]').forEach(function (e) { e.textContent = month; });
    } catch (e) { /* keep server month */ }
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href^="#"]') : null;
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var d = id ? document.getElementById(id) : null;
      if (d && d.tagName === 'DETAILS') d.open = true;
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();

/* FLP kit: study chart animation (bars grow, % counts up, once, when 35% visible; respects reduced motion) */
(function () {
  if (window.__flpStudyAnim) return; window.__flpStudyAnim = true;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var charts = document.querySelectorAll('.flp .study-chart');
  if (!charts.length) return;
  function countUp(el) {
    var end = parseInt(el.getAttribute('data-end'), 10); if (!end) return;
    var t0 = null, dur = 1600;
    function step(ts) {
      if (!t0) t0 = ts;
      var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(end * e) + '%';
      if (p < 1) window.requestAnimationFrame(step);
    }
    window.requestAnimationFrame(step);
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (!en.isIntersecting) return;
      var c = en.target; io.unobserve(c);
      c.classList.add('is-in');
      c.querySelectorAll('.sbar-num').forEach(countUp);
    });
  }, { threshold: 0.35 });
  charts.forEach(function (c) {
    c.querySelectorAll('.sbar-num').forEach(function (n) {
      var v = parseInt(n.textContent, 10); if (!isNaN(v)) { n.setAttribute('data-end', v); n.textContent = '0%'; }
    });
    c.classList.add('js-anim');
    io.observe(c);
  });
})();

/* FLP hero video: play once, stop on the last frame (the offer end card). Tapping the finished video goes to the
   buy box (#shop). Tapping a paused, unfinished video (autoplay blocked) plays it. */
(function () {
  function init() {
    var wraps = document.querySelectorAll('[data-flp-hero-vid]');
    Array.prototype.forEach.call(wraps, function (w) {
      var v = w.querySelector('video');
      if (!v || w.getAttribute('data-ready')) return;
      w.setAttribute('data-ready', '1');
      v.loop = false;
      function play() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      v.addEventListener('click', function () {
        if (v.ended) {
          var shop = document.getElementById('shop');
          if (shop) { shop.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
        }
        if (v.paused) play();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* FLP interaction tracking (2026-10-22). Every key interaction on an FLP page goes to Microsoft Clarity
   (custom event + session tag, so sessions can be filtered and funnels built in Clarity) and to GA4 via
   window.fireEvent (lp_-prefixed). Read in Clarity: Filters -> Custom events (flp_*) / Custom tags (flp_*).
   Events: flp_cta_click, flp_video_start, flp_video_end, flp_video_tap_shop, flp_open_study/_formula/_research,
   flp_formula_card. Tags: flp_cta_from, flp_depth. Sticky + buy-box events (sticky_shown/open/plan/atc,
   buybox_seen, product_atc_click) come from the site-wide snippets/clarity-persuasion-depth.liquid. */
(function () {
  if (window.__flpTrack) return; window.__flpTrack = true;
  var page = location.pathname;
  function depth() {
    var d = document.documentElement, pct = Math.min(100, Math.round((window.scrollY + window.innerHeight) / (d.scrollHeight || 1) * 100));
    var lo = Math.floor(pct / 10) * 10; return lo + '-' + (lo + 10) + '%';
  }
  var once = {};
  function track(name, tags, oneTime) {
    if (oneTime) { if (once[name]) return; once[name] = 1; }
    try {
      if (typeof window.clarity === 'function') {
        window.clarity('event', name);
        if (tags) for (var k in tags) if (tags[k] != null) window.clarity('set', k, String(tags[k]));
      }
    } catch (e) {}
    try { if (typeof window.fireEvent === 'function') { var p = { page: page }; if (tags) for (var t in tags) p[t] = tags[t]; window.fireEvent(name, p); } } catch (e) {}
  }
  function from(el) {
    var s = el.closest('section[id], [id^="s"], .flp-section');
    return (s && (s.id || (s.querySelector('[id]') || {}).id)) || 'unknown';
  }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;
    var x;
    if ((x = t.closest('[data-open-study]'))) return track('flp_open_study');
    if ((x = t.closest('[data-open-formula]'))) return track('flp_open_formula');
    if ((x = t.closest('[data-open-research]'))) return track('flp_open_research');
    if ((x = t.closest('[data-formula]'))) return track('flp_formula_card');
    if ((x = t.closest('video.flp-hero-vid'))) { if (x.ended) track('flp_video_tap_shop'); return; }
    if ((x = t.closest('a[href^="#shop"], a[href^="#offer"]'))) {
      if (x.closest('[data-flp-sticky]')) return track('flp_cta_click', { flp_cta_from: 'sticky_scroll_bar', flp_depth: depth() });
      return track('flp_cta_click', { flp_cta_from: from(x), flp_depth: depth() });
    }
  }, true);
  function init() {
    var v = document.querySelector('video.flp-hero-vid');
    if (v) {
      v.addEventListener('playing', function () { track('flp_video_start', null, true); });
      v.addEventListener('ended', function () { track('flp_video_end', null, true); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
